// extracted by mini-css-extract-plugin
export default {"colors":"accent,neutral,negative,warning,positive","listBoxItem":"styles_listBoxItem__JKMB0","separator":"styles_separator__msx+r"};